import { useMutation, useQueryClient } from "@tanstack/react-query";
import { vinculosApi } from "../api/vinculosApi";

// Favoritar só muda a ordem das listas de vínculo e a pré-seleção do cadastro de plantão:
// basta recarregar os vínculos, sem invalidar dashboard/calendário.
export function useSetVinculoFavoritoMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, favorito }) => vinculosApi.setFavorito(id, favorito),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["vinculos"] }),
  });
}
